<template>
  <vs-card>
    <div slot="header">
      <h2 class="float-left">Créditos</h2>

      <vs-button
          @click="updateCredits()"
          color="success"
          :disabled="!dataUpdated"
          class="float-right">Actualizar</vs-button>

      <div class="clearfix"></div>
    </div>
      <vs-table stripe :data="credits" v-model="itemsSelected">
        <template slot="thead" class="thead-dark">
          <vs-th>
            <vs-checkbox
                v-model="allCheck"
                @change="selectedAll()"
            />
          </vs-th>
          <vs-th>Fecha de actualización</vs-th>
          <vs-th>Nombre otorgante</vs-th>
          <vs-th>Clave prevención</vs-th>
          <vs-th>Tipo de cuenta</vs-th>
          <vs-th>Tipo de credito</vs-th>
          <vs-th>Moneda</vs-th>
          <vs-th>Fecha del ultimo pago</vs-th>
          <vs-th>Fecha apertura crédito</vs-th>
          <vs-th>Numero de pagos</vs-th>
          <vs-th style="width: 6vw;">Monto a pagar</vs-th>
          <vs-th style="width: 6vw;">Crédito máximo</vs-th>
          <vs-th style="width: 6vw;">Peor atraso</vs-th>
          <vs-th style="width: 6vw;">Saldo actual</vs-th>
          <vs-th style="width: 6vw;">Limite de crédito</vs-th>
          <vs-th style="width: 5vw;">Saldo vencido</vs-th>
          <vs-th>Numero de pagos vencido</vs-th>
          <vs-th>Total de pagos reportados</vs-th>
          <vs-th>Historico</vs-th>
        </template>
      <template slot-scope="{data}">
        <vs-tr
            not-click-selected
            open-expand-only-td
            :key="credit.id"
            v-for="credit in data">
          <vs-td checkbox>
            <vs-checkbox v-model="credit.selected" @change="notifyDataUpdates()"></vs-checkbox>
          </vs-td>
          <vs-td>{{credit.fechaActualizacion}}</vs-td>
          <vs-td>{{credit.nombreOtorgante}}</vs-td>
          <vs-td>{{credit.clavePrevencion}}</vs-td>
          <vs-td>{{credit.tipoCuenta}}</vs-td>
          <vs-td>{{credit.tipoCredito}}</vs-td>
          <vs-td>{{credit.claveUnidadMonetaria}}</vs-td>
          <vs-td>{{credit.fechaUltimoPago}}</vs-td>
          <vs-td>{{credit.fechaAperturaCuenta}}</vs-td>
          <vs-td>{{credit.numeroPagos}}</vs-td>
          <vs-td>
            <edit-text-component
                @change="notifyDataUpdates()"
                v-model="credit.montoPagar"
                :is-currency="true"></edit-text-component>
          </vs-td>
          <vs-td>
            <edit-text-component
                @change="notifyDataUpdates()"
                v-model="credit.creditoMaximo"
                :is-currency="true"></edit-text-component>
          </vs-td>
          <vs-td>{{credit.peorAtraso}}</vs-td>
          <vs-td>{{credit.saldoActual|_currency(0)}}</vs-td>
          <vs-td>{{credit.limiteCredito|_currency(0)}}</vs-td>
          <vs-td>
            <edit-text-component
                @change="notifyDataUpdates()"
                v-model="credit.saldoVencido"
                :is-currency="true"></edit-text-component>
          </vs-td>
          <vs-td>{{credit.numeroPagosVencidos}}</vs-td>
          <vs-td>{{credit.totalPagosReportados}}</vs-td>
          <vs-td>
            <span>{{ credit.historicoPagos }}</span>
            <vs-button v-if="false" size="sm">H</vs-button>
          </vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td></vs-td>
          <vs-td></vs-td>
          <vs-td></vs-td>
          <vs-td></vs-td>
          <vs-td></vs-td>
          <vs-td></vs-td>
          <vs-td></vs-td>
          <vs-td></vs-td>
          <vs-td></vs-td>
          <vs-td>{{sum('numeroPagos')}}</vs-td>
          <vs-td>{{sum('montoPagar')|_currency(0)}}</vs-td>
          <vs-td>{{sum('creditoMaximo')|_currency(0)}}</vs-td>
          <vs-td>{{sum('peorAtraso')}}</vs-td>
          <vs-td>{{sum('saldoActual')|_currency(0)}}</vs-td>
          <vs-td>{{sum('limiteCredito')|_currency(0)}}</vs-td>
          <vs-td>{{sum('saldoVencido')|_currency(0)}}</vs-td>
          <vs-td>{{sum('numeroPagosVencidos')}}</vs-td>
          <vs-td>{{sum('totalPagosReportados')}}</vs-td>
          <vs-td></vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vs-card>
</template>

<script>
import _ from 'lodash'
import {currency} from '@/filters/currency'
import EditTextComponent from "@components/editText/EditTextComponent";

export default {
  name: "ci-credits-table",
  components: {EditTextComponent},
  props: ["credits", "rfc", "person"],
  data: () => ({
    itemsSelected: [],
    allCheck: false,
    dataUpdated: false
  }),
  filters: {
    _currency: function(value, d) {
      if(isNaN(value)) {
        return 0;
      }
      return currency(parseFloat(value), d)
    }
  },
  methods: {
    sum(index) {
      return _.sumBy(this.credits, (credit) => {
        if(typeof credit[index] === "undefined") {
          return 0;
        }
        return parseFloat(credit[index]);
      })
    },
    selectedAll() {
      this.credits.forEach((credit) => credit.selected = this.allCheck)
      this.notifyDataUpdates()
    },
    notifyDataUpdates() {
      this.dataUpdated = true;
    },
    async updateCredits() {
      this.$vs.loading();
      try {
        const {data} = await axios.put(`/api/credit-score/personal/${this.person.id}`, this.credits);
        this.$emit("creditsUpdated", data)
      } catch(err) {
        swal("Error", "No se pudo actualizar los creditos seleccionados.")
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>

<style scoped>
.text-red {
  color: red;
}
</style>
